import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteProject, closeDeleteProjectModal } from 'redux/actions/projects'

const DeleteModal = ({ isOpen, closeModal, project, deleteProject, isLoading, source, history }) => !project ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Proyecto</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar el proyecto {project.name} ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteProject({project, source, history})}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  project: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteProject: PropTypes.func.isRequired,
}

const mapStateToProps = ({ projects: { source, openedDeleteProjectModal, selectedProject, deletingProject }}) => {
  return ({
    source,
    isOpen: openedDeleteProjectModal,
    project: selectedProject,
    isLoading: deletingProject
  })
}

const mapDispatchToProps = dispatch => ({
  deleteProject: info => dispatch(deleteProject(info)),
  closeModal: () => dispatch(closeDeleteProjectModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
